module.exports = __webpack_public_path__ + "img/bv.d27dd8f0.svg";